import { render, staticRenderFns } from "./form-questions.vue?vue&type=template&id=cb3abbea&scoped=true"
import script from "./form-questions.vue?vue&type=script&lang=js"
export * from "./form-questions.vue?vue&type=script&lang=js"
import style0 from "./form-questions.vue?vue&type=style&index=0&id=cb3abbea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3abbea",
  null
  
)

export default component.exports